import axios from 'axios';
import type { 
  Company, 
  CompanyQueryParams, 
  CompanySearchParams 
} from '@/types/company';
import { getApiUrl } from '@/config/config';

// 硬编码API URL，使用域名而不是IP
const API_URL = 'https://aivitahelper.xyz:8081/api/companies';

export const companyService = {
  // 创建公司
  createCompany: async (company: Company) => {
    const response = await axios.post(API_URL, company);
    return response.data;
  },

  // 更新公司
  updateCompany: async (company: Company) => {
    if (!company.id) {
      throw new Error('公司ID不能为空');
    }
    const response = await axios.put(`${API_URL}/${company.id}`, company);
    return response.data;
  },

  // 删除公司
  deleteCompany: async (id: number) => {
    const response = await axios.delete(`${API_URL}/${id}`);
    return response.data;
  },

  // 获取单个公司详情
  getCompany: async (id: number) => {
    const response = await axios.get(`${API_URL}/${id}`);
    return response.data;
  },

  // 条件查询公司
  queryCompanies: async (params: CompanyQueryParams) => {
    const response = await axios.get(API_URL, { params });
    return response.data;
  },

  // 关键字搜索公司
  searchCompanies: async (params: CompanySearchParams) => {
    const response = await axios.get(`${API_URL}/search`, { params });
    return response.data;
  }
}; 